export const WorksActionTypes = {
    UPDATE_WORKS: 'UPDATE_WORKS',
    SET_CURRENT_ITEM: 'SET_CURRENT_ITEM',
    UPDATE_CURRENT_ITEM: 'UPDATE_CURRENT_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
}